var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 9.92969C6.42969 9.92969 7.125 9.23438 7.125 8.36719C7.125 7.50781 6.42969 6.8125 5.5625 6.8125C4.69531 6.8125 4 7.50781 4 8.36719C4 9.23437 4.69531 9.92969 5.5625 9.92969Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 15.7344C6.42969 15.7344 7.125 15.0391 7.125 14.1719C7.125 13.2891 6.42969 12.5937 5.5625 12.5937C4.69531 12.5937 4 13.2891 4 14.1719C4 15.0391 4.69531 15.7344 5.5625 15.7344Z",
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 4.14844C6.42969 4.14844 7.125 3.44531 7.125 2.5625C7.125 1.70312 6.42969 1 5.5625 1C4.69531 1 4 1.70312 4 2.5625C4 3.44531 4.69531 4.14844 5.5625 4.14844Z",
    fill: "#A0A0A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 9.92969C11.9922 9.92969 12.6875 9.23438 12.6875 8.36719C12.6875 7.50781 11.9922 6.8125 11.125 6.8125C10.2578 6.8125 9.5625 7.50781 9.5625 8.36719C9.5625 9.23437 10.2578 9.92969 11.125 9.92969Z",
    fill: "#A0A0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 15.7344C11.9922 15.7344 12.6875 15.0391 12.6875 14.1719C12.6875 13.2891 11.9922 12.5937 11.125 12.5937C10.2578 12.5937 9.5625 13.2891 9.5625 14.1719C9.5625 15.0391 10.2578 15.7344 11.125 15.7344Z",
    fill: "#A0A0A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 4.14844C11.9922 4.14844 12.6875 3.44531 12.6875 2.5625C12.6875 1.70312 11.9922 1 11.125 1C10.2578 1 9.5625 1.70312 9.5625 2.5625C9.5625 3.44531 10.2578 4.14844 11.125 4.14844Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.e722e16f30432824c24791651dfa8d75.svg";
export { ForwardRef as ReactComponent };